import { Component, Input, Output, EventEmitter, TemplateRef } from "@angular/core";
import { ColumnMode } from '@swimlane/ngx-datatable';

export interface SharedTableColumn {
  name: string;
  prop?: string;
  width?: number;
  sortable?: boolean;
  headerClass?: string;
  cellClass?: string;
  template?: TemplateRef<any>;
}

@Component({
    selector: 'app-shared-table',
    templateUrl: './shared-table.component.html',
    standalone: false
})
export class SharedTableComponent {
  ColumnMode = ColumnMode;

  @Input() rows: any[] = [];
  @Input() columns: SharedTableColumn[] = [];
  @Input() totalLength = 0;
  @Input() currentPage = 0;
  @Input() pageSize = 10;

  @Output() pageChange = new EventEmitter<any>();
  @Output() sortChange = new EventEmitter<any>();
}
